import { ProfilePermissionTypeDto } from './profile-permission-type.dto';
import { ProfileRead } from '../profile-read.model';

export interface ProfilePermissionDto {
  Id: number;
  ProfileId: number;
  TargetProfileId: number;
  ProfilePermissionTypeId: number;
}

export function initializedProfilePermissionDto(partialDto?: Partial<ProfilePermissionDto>): ProfilePermissionDto {
  const defaultDto = {
    ProfilePermissionTypeId: 1,
  } as ProfilePermissionDto;
  return { ...defaultDto, ...(partialDto ?? {}) };
}
